import colors from './colors'
import transitions from './transitions'
import decorations from './decorations'
import typography from './typography'
import * as helpers from './helpers'

export default {
  ...helpers,
  ...{
    color: (name, tint = 100) => colors[name][tint],
    transitions,
    decorations,
    typography,
  },
}
